export function getClosest (elem, selector) {
    // Element.matches() polyfill
    if (!Element.prototype.matches) {
        Element.prototype.matches =
        Element.prototype.matchesSelector ||
        Element.prototype.mozMatchesSelector ||
        Element.prototype.msMatchesSelector ||
        Element.prototype.oMatchesSelector ||
        Element.prototype.webkitMatchesSelector ||
        function (s) {
            var matches = (this.document || this.ownerDocument).querySelectorAll(s)
            var i = matches.length
            while (--i >= 0 && matches.item(i) !== this) {}
            return i > -1
        }
    }

    // Get the closest matching element
    for (; elem && elem !== document; elem = elem.parentNode) {
        if (elem.matches(selector)) return elem
    }
    return null
}

export function isDevice () {
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true
    }
}

export function scrollLock (lock = 'lock') {
    if (lock === 'lock') {
        document.body.classList.add('scroll-lock')
    } else {
        document.body.classList.remove('scroll-lock')
    }
}

export function getHeight (elem) {
    const height = Math.max(elem.scrollHeight, elem.clientHeight, elem.offsetHeight, elem.scrollHeight, elem.offsetHeight, elem.clientHeight)
    return height
}

export function capitalize (string, allWords = false) {
    if (allWords) {
        return string.replace(/\w\S*/g, function (txt) { return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase() })
    } else {
        return string.charAt(0).toUpperCase() + string.slice(1)
    }
}

export function getUrlParams (search = window.location.search) {
    let hashes = search.slice(search.indexOf('?') + 1).split('&')
    let params = {}
    hashes.map(hash => {
        let [key, val] = hash.split('=')
        params[key] = decodeURIComponent(val)
    })
    return params
}



// WEBPACK FOOTER //
// ./src/resources/scripts/helpers/general.js